export default __webpack_public_path__ + "static/media/image4.ff7a511c.png";